"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    sihuaLu: '록',
    sihuaQuan: '권',
    sihuaKe: '과',
    sihuaJi: '기',
};
